import * as angular from 'angular';

import { ILoggerService, IApplicationService } from '../../services';
import { Application, ComponentDefinition } from '../../models';

class ExportApplicationController implements angular.IComponentController {
    isLoading: boolean;
    readonly selectedApplication: Application;

    static $inject = [
        'applicationService',
        'loggerService'
    ];

    constructor(
        private _applicationService: IApplicationService,
        private _loggerService: ILoggerService
    ) {
    }

    exportApplication(): void {
        this.isLoading = true;

        this._applicationService.getExport(this.selectedApplication.guid,
            (data, baseUrl) => {
                try {
                    window.open(`${baseUrl}${data}`);
                    this.isLoading = false;
                } catch (e) {
                    this._loggerService.logError(e);
                    this.isLoading = false;
                }
            }
        );
    }
}

export const wtExportApplication: ComponentDefinition = {
    componentId: 'wtExportApplication',
    controller: ExportApplicationController,
    template: require('./exportApplication.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedApplication: '<'
    }
};
